import {z} from "zod/v4-mini"

export type Color = {r: number; g: number; b: number; a?: number}
export const color = z.object({r: z.number(), g: z.number(), b: z.number(), a: z.optional(z.number())}) satisfies z.ZodMiniType<Color>
